<template>
  <v-card class="mx-auto"  >
    <v-list-item>
        <v-list-item-content>
            <v-row>
                <v-col cols="1">
                    <v-card-actions class="justify-start">
                        <v-btn :to="'/cards'"><v-icon>mdi-arrow-left</v-icon></v-btn>
                    </v-card-actions>
                </v-col>
                <v-col cols="10">
                    <v-list-item-title class="headline">{{card.translations[0].title}}</v-list-item-title>
                    <v-list-item-subtitle>{{card.section.name}}</v-list-item-subtitle>
                </v-col>
                <v-col cols="1" >
                </v-col>
            </v-row>            
        </v-list-item-content>
    </v-list-item>

    <carousel :medias="getCurrentMedias" ></carousel>  
    
    <card-content :text="getCurrentText"></card-content>

    <v-card-actions class="justify-center">
        <v-btn v-if="help" @click="showHelp"><v-icon>mdi-comment-check</v-icon></v-btn>      
        <v-btn v-if="!help" @click="previous" :disabled="isFirst"><v-icon>mdi-arrow-left-bold-circle</v-icon></v-btn>
        <v-btn v-if="!help" @click="next" :disabled="isLast"><v-icon>mdi-arrow-right-bold-circle</v-icon></v-btn>  
        <v-btn v-if="!help" @click="showHelp"><v-icon>mdi-comment-question-outline</v-icon></v-btn>
    </v-card-actions>

  </v-card>
</template>

<script>
import Carousel from './Carousel';
import Content from './Content';
export default {
    data: () => ({
        currentText: -1,
        help: false
    }),
    components:{
        'carousel' : Carousel,
        'card-content' : Content
    },
    props: {
        card: {
            type: Object,
            required: true
        }
    },
    methods:{
        previous(){           
            this.currentText =  (this.currentText <= 0 ? -1 : this.currentText - 1);
        },
        next(){            
            this.currentText =  (this.currentText >= this.card.questions.length-1 ? this.card.questions.length-1 : this.currentText + 1);
        },      
        showHelp(){
            this.help = !this.help;
        }          
    },
    computed:{
        getCurrentText(){
            if(!this.help){
                return (this.currentText < 0 ? this.card.translations[0].introduction : this.card.questions[this.currentText].translations[0].text);          
            }else{
                return this.card.translations[0].help;
            }  
        },
        getCurrentMedias(){
            if(this.currentText >=0 && this.card.questions[this.currentText].media !== null){
                console.log(this.card.questions[this.currentText]);
                return [this.card.questions[this.currentText].media];
            }else{
                return this.card.medias;
            }
        },
        isFirst(){
            return (this.currentText == -1);
        },
        isLast(){
            return (this.currentText == this.card.questions.length-1);
        }
    }    
}
</script>